<div class="blank-layout-container justify-content-center">
  <div class="row">
    <div class="col-12 text-center">
      <img src="/assets/images/backgrounds/maintenance.svg" alt="unauthorized-access" />
      <h2 class="auth-title f-w-600 m-t-20">Access Denied</h2>
      <h6 class="f-s-20 f-w-600 m-y-30">
        You do not have permission to view this page.
      </h6>
      <a mat-flat-button color="primary" [routerLink]="['/dashboard']">
        Go back to Dashboard
      </a>
    </div>
  </div>
</div>
